export const updateIdea = (payload?: any) => ({
    type: "@saga/UPDATE_IDEA",
    payload
});

